import { useEffect } from 'react'
import i18n, { SUPPORTED_LANGUAGES } from '@/i18n'
import { configureLangHeader } from '@/libs/services'

const I18N_STORAGE_KEY = 'i18nextLng'

/**
 * Listens for localStorage 'storage' events so other open tabs update when one tab
 * changes the language (same approach as v2 language-storage-sync).
 * The tab that changed the language already has the new language; this syncs other tabs.
 * Works for both the anonymous language switcher (auth layout) and the normal one
 * (NoMenuLayout/SidebarMenu), since both use i18n.changeLanguage() and the same key (i18nextLng).
 */
export function LanguageStorageSync() {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof localStorage === 'undefined') return

    const handler = e => {
      if (e.key !== I18N_STORAGE_KEY || !e.newValue) return
      const lng = e.newValue.split('-')[0]
      if (!SUPPORTED_LANGUAGES.includes(lng)) return
      const current = (i18n.language || '').split('-')[0]
      if (current === lng) return
      i18n.changeLanguage(lng)
      configureLangHeader(lng)
    }
    window.addEventListener('storage', handler)
    return () => window.removeEventListener('storage', handler)
  }, [])
  return null
}
